<template>
  <div class="container mt-4">
     <!-- Breadcrumb -->
     <b-breadcrumb class="m-3">
      <b-breadcrumb-item href="/"> <i class="fa fa-home" aria-hidden="true"></i> Home</b-breadcrumb-item>
      <b-breadcrumb-item href="/residentslist-cont"> Residents</b-breadcrumb-item>
      <b-breadcrumb-item active> {{ getBread("-cont") }}</b-breadcrumb-item>
    </b-breadcrumb>
    <div class="customCard">
      <h1 style="font-size: 2rem; text-align: center; padding-bottom: 1rem">
        List of Contacts {{ fullName }}
      </h1>
    </div>

    <div v-if="loading" class="text-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-else-if="error" class="text-center text-danger">
      <p>Error loading data.</p>
    </div>
    <div v-else>
      <button class="btn btn-primary mb-4" @click="showAddModal = true">
        Add Contact
      </button>
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">Contact Name</th>
            <th scope="col">Contact Type</th>
            <th scope="col">Mobile Phone</th>
            <th scope="col">Email</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="contact in paginatedContacts" :key="contact.id">
            <td> <a href="#" @click.prevent="viewEntry(contact)">
              {{ contact.attributes.firstname }}
              {{ contact.attributes.lastname }}
            </a>
            </td>
            <td>{{ getContactTypeText(contact.attributes.contacttype) }}</td>
            <td>{{ contact.attributes.mobilephone }}</td>
            <td>{{ contact.attributes.email }}</td>
            <td><a href="#" @click.prevent="editEntry(contact)">Edit</a> </td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-between align-items-center">
        <p>
          Showing {{ startIndex + 1 }} to {{ endIndex }} of
          {{ result.residentcontacts.data.length }} entries
        </p>
        <ul class="pagination">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <a
              class="page-link"
              href="#"
              @click.prevent="changePage(currentPage - 1)"
              >Prev</a
            >
          </li>
          <li
            class="page-item"
            v-for="page in totalPages"
            :key="page"
            :class="{ active: currentPage === page }"
          >
            <a class="page-link" href="#" @click.prevent="changePage(page)">{{
              page
            }}</a>
          </li>
          <li
            class="page-item"
            :class="{ disabled: currentPage === totalPages }"
          >
            <a
              class="page-link"
              href="#"
              @click.prevent="changePage(currentPage + 1)"
              >Next</a
            >
          </li>
        </ul>
      </div>
    </div>

    <!-- Edit Modal -->
    <b-modal size="xl" v-model="showEditModal" hide-footer :title="'Edit Contact '+fullName">
      <form v-if="currentContact" @submit.prevent="updateEntry">
        <div class="row">
          <div class="col-md-4">
            <div class="mb-3">
              <label for="firstname" class="form-label">First Name</label>
              <input
                type="text"
                class="form-control"
                id="firstname"
                v-model="currentContact.attributes.firstname"
                required
              />
            </div>
            <div class="mb-3">
              <label for="lastname" class="form-label">Last Name</label>
              <input
                type="text"
                class="form-control"
                id="lastname"
                v-model="currentContact.attributes.lastname"
                required
              />
            </div>
            <div class="mb-3">
              <label for="contacttype" class="form-label">Contact Type</label>
              <select
                class="form-select"
                id="contacttype"
                v-model="currentContact.attributes.contacttype"
                required
              >
                <option
                  v-for="option in contactTypes"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="address" class="form-label">Address</label>
              <input
                type="text"
                class="form-control"
                id="address"
                v-model="currentContact.attributes.address"
                required
              />
            </div>
            <div class="mb-3">
              <label for="city" class="form-label">City</label>
              <input
                type="text"
                class="form-control"
                id="city"
                v-model="currentContact.attributes.city"
                required
              />
            </div>
            <div class="mb-3">
              <label for="state" class="form-label">State</label>
              <select
                class="form-select"
                id="state"
                v-model="currentContact.attributes.state"
                required
              >
                <option
                  v-for="option in usStates"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
            <div class="mb-3">
              <label for="zipcode" class="form-label">Zip Code</label>
              <input
                type="text"
                class="form-control"
                id="zipcode"
                v-model="currentContact.attributes.zipcode"
                required
              />
            </div>
            <div class="mb-3">
              <label for="email" class="form-label">Email</label>
              <input
                type="text"
                class="form-control"
                id="email"
                v-model="currentContact.attributes.email"
                required
              />
          </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="homephone" class="form-label">Home Phone</label>
              <input
                type="text"
                class="form-control"
                id="homephone"
                v-model="currentContact.attributes.homephone"
              />
            </div>
            <div class="mb-3">
              <label for="mobilephone" class="form-label">Mobile Phone</label>
              <input
                type="text"
                class="form-control"
                id="mobilephone"
                v-model="currentContact.attributes.mobilephone"
              />
            </div>
            <div class="mb-3">
              <label for="businessphone" class="form-label"
                >Business Phone</label
              >
              <input
                type="text"
                class="form-control"
                id="businessphone"
                v-model="currentContact.attributes.businessphone"
              />
            </div>
            <div class="mb-3">
              <label for="duties" class="form-label">Duties</label>
              <textarea
                class="form-control"
                id="duties"
                v-model="currentContact.attributes.duties"
              ></textarea>
            </div>
            <div class="mb-3">
              <label for="notes" class="form-label">Notes</label>
              <textarea
                class="form-control"
                id="notes"
                v-model="currentContact.attributes.notes"
              ></textarea>
            </div>
          </div>
          <div class="d-grid">
            <button type="submit" class="btn btn-primary">Save changes</button>
          </div>
        </div>
      </form>
      <div v-if="updateError" class="alert alert-danger mt-3">
        {{ updateError }}
      </div>
    </b-modal>

     <!-- View Modal -->
     <b-modal size="xl" v-model="showViewModal" hide-footer :title="'View Contact '+fullName">
      <form v-if="currentContact">
        <div class="row">
          <div class="col-md-4">
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">First Name:</strong>
              <span>{{ currentContact.attributes.firstname }} </span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Last Name:</strong>
              <span>{{ currentContact.attributes.lastname }} </span>              
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Contact Type:</strong>
              <span>{{ getContactTypeText(currentContact.attributes.contacttype) }}</span>               
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Address:</strong>
              <span>{{ currentContact.attributes.address }} </span>                
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">City:</strong>
              <span>{{ currentContact.attributes.city }} </span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">State:</strong>
              <span>{{ currentContact.attributes.state }}</span>                
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Zip Code:</strong>
              <span>{{ currentContact.attributes.zipcode }} </span>                
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Email:</strong>
              <span>{{ currentContact.attributes.email }}</span>               
          </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Home Phone:</strong>
              <span>{{ currentContact.attributes.homephone }}</span>              
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Mobile Phone:</strong>
              <span>{{ currentContact.attributes.mobilephone }}</span>             
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Business Phone:</strong>
              <span>{{ currentContact.attributes.businessphone }} </span>
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Duties:</strong>
              <span>{{ currentContact.attributes.duties }} </span>              
            </div>
            <div class="mb-3 d-flex flex-row align-items-center">
              <strong class="me-2">Notes:</strong>
              <span>{{ currentContact.attributes.notes }} </span>              
            </div>
          </div>         
        </div>
      </form>
    </b-modal>

    <!-- Add Modal -->
    <b-modal size="xl" v-model="showAddModal" hide-footer :title="'Add Contact '+fullName">
      <form @submit.prevent="addEntry">
        <div class="row">
          <div class="col-md-4">
            <div class="mb-3">
              <label for="firstname" class="form-label">First Name</label>
              <input
                type="text"
                class="form-control"
                id="firstname"
                v-model="newContact.firstname"
                required
              />
            </div>
            <div class="mb-3">
              <label for="lastname" class="form-label">Last Name</label>
              <input
                type="text"
                class="form-control"
                id="lastname"
                v-model="newContact.lastname"
                required
              />
            </div>
            <div class="mb-3">
              <label for="contacttype" class="form-label">Contact Type</label>
              <select
                class="form-select"
                id="contacttype"
                v-model="newContact.contacttype"
                required
              >
                <option
                  v-for="option in contactTypes"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="address" class="form-label">Address</label>
              <input
                type="text"
                class="form-control"
                id="address"
                v-model="newContact.address"
                required
              />
            </div>
            <div class="mb-3">
              <label for="city" class="form-label">City</label>
              <input
                type="text"
                class="form-control"
                id="city"
                v-model="newContact.city"
                required
              />
            </div>
            <div class="mb-3">
              <label for="state" class="form-label">State</label>
              <select
                class="form-select"
                id="state"
                v-model="newContact.state"
                required
              >
                <option
                  v-for="option in usStates"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select>
            </div>
            <div class="mb-3">
              <label for="zipcode" class="form-label">Zip Code</label>
              <input
                type="text"
                class="form-control"
                id="zipcode"
                v-model="newContact.zipcode"
                required
              />
            </div>
            <div class="mb-3">
              <label for="email" class="form-label">Email</label>
              <input
                type="text"
                class="form-control"
                id="email"
                v-model="newContact.email"
                required
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="mb-3">
              <label for="homephone" class="form-label">Home Phone</label>
              <input
                type="text"
                class="form-control"
                id="homephone"
                v-model="newContact.homephone"
              />
            </div>
            <div class="mb-3">
              <label for="mobilephone" class="form-label">Mobile Phone</label>
              <input
                type="text"
                class="form-control"
                id="mobilephone"
                v-model="newContact.mobilephone"
              />
            </div>
            <div class="mb-3">
              <label for="businessphone" class="form-label"
                >Business Phone</label
              >
              <input
                type="text"
                class="form-control"
                id="businessphone"
                v-model="newContact.businessphone"
              />
            </div>
            <div class="mb-3">
              <label for="duties" class="form-label">Duties</label>
              <textarea
                class="form-control"
                id="duties"
                v-model="newContact.duties"
              ></textarea>
            </div>
            <div class="mb-3">
              <label for="notes" class="form-label">Notes</label>
              <textarea
                class="form-control"
                id="notes"
                v-model="newContact.notes"
              ></textarea>
            </div>
          </div>
          <div class="d-grid">
            <button type="submit" class="btn btn-primary">Add contact</button>
          </div>
        </div>
      </form>
      <div v-if="addError" class="alert alert-danger mt-3">
        {{ addError }}
      </div>
    </b-modal>
  </div>
</template>
  
  <script>
import { useQuery, useMutation } from "@vue/apollo-composable";
import { GET_CONTACTS_BY_RESIDENT, UPDATE_CONTACT, CREATE_CONTACT, GET_FULLNAME_BY_ID} from "../hooks/queries";
import { ref, computed } from "vue";
import { BModal } from "bootstrap-vue-next";
import { contactTypes, usStates, getBread } from "../components/values";
import { useRoute } from 'vue-router'; // Import useRoute from Vue Router  

export default {
  name: "ResContact",
  components: {
    BModal,
  },
  setup() {    
    const route = useRoute(); 
    const residentId = route.params.id; // Access the route parameter directly
    const { result:result, loading:loading, error:error, refetch:refetch } = useQuery(GET_CONTACTS_BY_RESIDENT,{residentId: residentId});
    const { mutate: updateResidentcontact } = useMutation(UPDATE_CONTACT);
    const { mutate: createContact } = useMutation(CREATE_CONTACT);
    const currentContact = ref(null);
    const updateError = ref(null);
    const addError = ref(null);
    const showEditModal = ref(false);
    const showAddModal = ref(false);
    const showViewModal = ref(false);

    const {result:resultfullname, loading:loadingfullname, error:errorfullname, refetch:refetchfullname } = useQuery(GET_FULLNAME_BY_ID, {
      id: residentId,
    });

      // Watch the result and compute the full name only when the data is available
      const fullName = computed(() => {
      const data = resultfullname.value?.resident?.data;
      if (data) {
        return `(${data.attributes.firstname} ${data.attributes.lastname})`;
      }
      return null;
    });


    const newContact = ref({
      firstname: "",
      lastname: "",
      contacttype: "",
      duties: "",
      address: "",
      city: "",
      state: "",
      zipcode: "",
      notes: "",
      homephone: "",
      businessphone: "",
      mobilephone: "",
      email: "",
      publishedAt: new Date().toISOString(),
    });

    const addEntry = async () => {
      addError.value = null;
      try {
        await createContact({
          data: {
            resident: residentId, // Include the residentId in the input data
            firstname: newContact.value.firstname,
            lastname: newContact.value.lastname,
            contacttype: newContact.value.contacttype,
            duties: newContact.value.duties,
            address: newContact.value.address,
            city: newContact.value.city,
            zipcode: newContact.value.zipcode,
            state: newContact.value.state,
            notes: newContact.value.notes,
            homephone: newContact.value.homephone,
            businessphone: newContact.value.businessphone,
            mobilephone: newContact.value.mobilephone,
            email: newContact.value.email,
            publishedAt: new Date().toISOString(),
          },
        });
        showAddModal.value = false;
        newContact.value = {
          firstname: "",
          lastname: "",
          contacttype: "",
          duties: "",
          address: "",
          city: "",
          state: "",
          zipcode: "",
          notes: "",
          homephone: "",
          businessphone: "",
          mobilephone: "",
          email: "",
        };
        await refetch(); // Refetch the list of contacts after adding a new one
        await refetchfullname();
      } catch (e) {
        //console.error("Error adding entry:", e);
        addError.value = `Failed to add contact. Please try again.}`;
      }
    };

    const formatDate = (date) => {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(date).toLocaleDateString(undefined, options);
    };

    const editEntry = (contact) => {
      //currentContact.value = { ...contact }; // Copy contact to avoid directly modifying the original data
      currentContact.value = JSON.parse(JSON.stringify(contact)); // Create a deep copy of the docuement object
      showEditModal.value = true;
    };

    const updateEntry = async () => {
      updateError.value = null; // Reset the error message
      try {
        await updateResidentcontact({
          id: currentContact.value.id,
          data: {
            firstname: currentContact.value.attributes.firstname,
            lastname: currentContact.value.attributes.lastname,
            contacttype: currentContact.value.attributes.contacttype,
            duties: currentContact.value.attributes.duties,
            address: currentContact.value.attributes.address,
            city: currentContact.value.attributes.city,
            state: currentContact.value.attributes.state,
            zipcode: currentContact.value.attributes.zipcode,
            notes: currentContact.value.attributes.notes,
            homephone: currentContact.value.attributes.homephone,
            mobilephone: currentContact.value.attributes.mobilephone,
            businessphone: currentContact.value.attributes.businessphone,
            businessmobile: currentContact.value.attributes.businessmobile,
            email: currentContact.value.attributes.email,
          },
        });
        //console.log("Updated entry:", currentContact.value);
        showEditModal.value = false;
      } catch (error) {
        //console.error("Error updating entry:", error);
        updateError.value = "Failed to update Contact. Please try again.";
      }
    };

    const viewEntry = (contact) => {
      currentContact.value = JSON.parse(JSON.stringify(contact)); // Create a deep copy of the contact object
      showViewModal.value = true;
    };

    const getContactTypeText = (value) => {
      const option = contactTypes.find((option) => option.value === value);
      return option ? option.text : "";
    };

    const getStates = (value) => {
      const option = usStates.find((option) => option.value === value);
      return option ? option.text : "";
    };

    return {
      result,
      loading,
      error,
      formatDate,
      showEditModal,
      showAddModal,
      showViewModal,
      currentContact,
      newContact,
      editEntry,
      viewEntry,
      updateEntry,
      addEntry,
      updateError,
      addError,
      contactTypes,
      getContactTypeText,
      getStates,
      usStates,
      errorfullname,
      loadingfullname,
      fullName,  
      getBread,
    };
  },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(
        this.result.residentcontacts.data.length / this.itemsPerPage
      );
    },
    paginatedContacts() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.result.residentcontacts.data.slice(
        start,
        start + this.itemsPerPage
      );
    },
    startIndex() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
    endIndex() {
      return Math.min(
        this.startIndex + this.itemsPerPage,
        this.result.residentcontacts.data.length
      );
    },
  },
  methods: {
    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
  },
};
</script>
  
  <style>
.container {
  max-width: 80%;
}

.d-grid {
  background-color: #e8e8e8;
  margin-bottom: 20px;
}

.text-center {
  text-align: center;
}
.spinner-border {
  margin-top: 20px;
}
.pagination {
  margin: 0;
}
</style>
  
